export default "__VITE_ASSET__DHR4INw___"